<script>
  import VisionneuseImages from './VisionneuseImages.vue'
  export default {
    name: 'GalerieImages',
    components: {
      VisionneuseImages,
    },
    props: {
      donnees: {
        type: Array,
        required: true,
        default: () => [],
      },
      categorie: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        estVisionneuseOuverte: false,
        compteur: 0,
      }
    },
    methods: {
      ouvrirVisionneuse(index) {
        this.compteur = index
        this.estVisionneuseOuverte = true
      },
      fermerVisionneuse() {
        this.estVisionneuseOuverte = false
      },
    },
  }
</script>

<template>
  <ul class="galerie-oeuvres">
    <li v-for="(data, index) in donnees" :key="data.id">
      <img
        class="image-galerie"
        :src="`/visuels/${this.categorie}/small/${data.image}`"
        @click="ouvrirVisionneuse(index)"
        alt=""
      />
    </li>
  </ul>

  <VisionneuseImages
    v-if="estVisionneuseOuverte"
    :donnees="donnees"
    :categorie="categorie"
    :compteur-initial="compteur"
    @fermer-visionneuse="fermerVisionneuse"
  />
</template>

<style scoped>
  .galerie-oeuvres {
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    width: min(1200px, 90vw);
    display: grid;
    gap: 1em;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    list-style-type: none;
    margin: 2em 0;
  }
  .image-galerie {
    cursor: pointer;
    width: 100%;
    height: 100%;
    max-width: 300px;
    max-height: 300px;
    object-fit: cover;
    object-position: center;
    display: flex;
    align-items: center;
    transition: all 0.15s ease;
  }

  .image-galerie:hover {
    padding: 0.25em;
  }

  li {
    display: flex;
    justify-content: center;
  }
</style>
